type OrderItem = {
  product?: { Image?: string | null; Name?: string | null } | null;
};

export type OrderImage = {
  src: string;
  alt: string;
};

export function getUniqueOrderImages(items: OrderItem[]): OrderImage[] {
  const seen = new Set<string>();

  return items.reduce<OrderImage[]>((results, item) => {
    const src = item.product?.Image;
    if (typeof src === 'string' && src !== '' && !seen.has(src)) {
      seen.add(src);
      results.push({ src, alt: item.product?.Name ?? '' });
    }
    return results;
  }, []);
}
